import React from 'react'
import Dashboard from '../Components/Dashboard'
import { Outlet } from 'react-router-dom';


const Home = () => {
  return (
    <>
      <Dashboard/> 
      <div >
      <Outlet  />
      </div>
    </>
  )
}

export default Home